import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';

import EnhancedTab from '../../../../lib/designSystem/TabSimulation';
// import Discounts from './components/Discounts';
import { hasAnyPermissions } from '../../../../lib/functions/utils';
import { AuthState } from '../../../../services/redux/authSlice';
import Accounts from './components/Accounts';
import Discounts from './components/Discounts';
import FNC from './components/FNC';
import PayIns from './components/PayIns';
import Payouts from './components/PayOuts';

const Payments = () => {
  const user = useSelector((state: { auth: AuthState }) => state.auth.user);
  const { subPage } = useParams<{ page: string; subPage: string }>();
  const [startValue, setStartValue] = useState(0);

  const tabs: {
    label: string;
    component: any;
    path: string;
    disabled?: boolean;
  }[] = [];
  if (hasAnyPermissions(user, ['financing_payout_view'])) {
    tabs.push({
      label: 'Enviados',
      component: <Payouts />,
      path: 'out',
    });
  }
  if (hasAnyPermissions(user, ['financing_payIn_view'])) {
    tabs.push({
      label: 'recibidos',
      component: <PayIns />,
      path: 'in',
    });
    if (hasAnyPermissions(user, ['financing_pending_accounts_view']))
      tabs.push({
        label: 'Cuentas',
        component: <Accounts />,
        path: 'accounts',
      });
  }
  if (hasAnyPermissions(user, ['financing_discount_view'])) {
    tabs.push({
      label: 'Condonación',
      component: <Discounts />,
      path: 'discounts',
    });
  }
  if (hasAnyPermissions(user, ['financing_fnc_view'])) {
    tabs.push({
      label: 'FNC',
      component: <FNC />,
      path: 'fnc',
    });
  }

  const navigate = useNavigate();

  const handleNavigation = (index: number) => {
    navigate(`/finance/payments/${tabs[index].path}`);
  };

  useEffect(() => {
    let subPageIndex = tabs.findIndex((x: any) => x.path === subPage);
    subPageIndex = subPageIndex === -1 ? 0 : subPageIndex;
    handleNavigation(subPageIndex);
    setStartValue(subPageIndex);
  }, []);

  return (
    <div>
      <EnhancedTab
        startValue={startValue}
        tabs={tabs}
        onTabChange={handleNavigation}
      />
    </div>
  );
};

export default Payments;
